// extracted by mini-css-extract-plugin
export default {"payButton":"IxMgS","modalContainer":"Jq8zb","modalHeader":"PR1-s","modalBody":"Dxv0x","skeletonWidget":"R6kHu","skeleton-progress":"P-QYf"};